const environment = {
    baseUrl: "https://apigw-feature2-qa.blinkng.com/host",
    semaBaseUrl: "https://apigw-feature2-qa.blinkng.com",
    googleMapKey: "AIzaSyCqFay6qqmew8KKgujKBlhSNzA7RAr4yqQ",
    keyCloakurl: "https://feature2-account-qa.blinkng.com/auth",
    keyCloakRealm: "blinkcharging",
    keyCloakClientId: "host-webapp-localhost",
    googleTimezoneUrl: "https://maps.googleapis.com/maps/api/timezone/json",
    staticSiteUrl: "https://static-qa.blinkng.com",
    powerBiTenantId:"46369f9c-6034-435a-9163-6c1e71b24dd6",
    powerBiGroupId:"555554fe-1737-466c-92b0-6749d79e39fa",
    powerBiAnalyticsName: "ReportSection9295ed54559ab933ad5d",
    powerBiAnalyticsReportId :"9c25b84e-b4b7-4a5b-8c1a-f2fb8c0526b3",
    powerBiAnalyticsReportsName: {
        sustainability: 'ReportSection6313e08e2c700225ec0c',
        hostrevenue: 'ReportSectiond0f03865d62bc2dad499',
        chargingsessions: 'ReportSection20e37d19282bbb250b34',
    },
    powerBiStationUsageName: "ReportSectionaffc5bba152083de6d26",
    powerBiStationUsageReportId :"9457fbfc-417e-477b-a598-70a4eff976f8",
    powerBiStationUsageReportsName: {
        stationusage: 'ReportSectionaffc5bba152083de6d26',
    }
};
switch (process.env.REACT_APP_ENV) {

    case "development":
        environment.baseUrl = "https://apigw-qa.blinkng.com/host";
        environment.semaBaseUrl = "https://apigw-qa.blinkng.com";
        environment.keyCloakurl = "https://account-qa.blinkng.com/auth";
        environment.keyCloakClientId = "host-webapp-qa";
        environment.keyCloakRealm = "blinkcharging";
        environment.staticSiteUrl = "https://static-qa.blinkng.com";
        break;
    
    case "developmentfeature1":
        environment.baseUrl = "https://apigw-feature1-qa.blinkng.com/host";
        environment.keyCloakurl = "https://account-qa.blinkng.com/auth";
        environment.keyCloakClientId = "host-webapp-qa";
        environment.keyCloakRealm = "blinkcharging_feature1";
        environment.staticSiteUrl = "https://feature1-static-qa.blinkng.com";
        break;
    case "developmentfeature2":
        environment.baseUrl = "https://apigw-feature2-qa.blinkng.com/host";
        environment.semaBaseUrl = "https://apigw-feature2-qa.blinkng.com";
        environment.keyCloakurl = "https://feature2-account-qa.blinkng.com/auth";
        environment.keyCloakClientId = "host-webapp-qa";
        environment.keyCloakRealm = "blinkcharging";
        environment.staticSiteUrl = "https://feature2-static-qa.blinkng.com";
        environment.powerBiTenantId="46369f9c-6034-435a-9163-6c1e71b24dd6";
        environment.powerBiGroupId="555554fe-1737-466c-92b0-6749d79e39fa";
        environment.powerBiAnalyticsName  = "ReportSection9295ed54559ab933ad5d";
        environment.powerBiAnalyticsReportId ="9c25b84e-b4b7-4a5b-8c1a-f2fb8c0526b3";
        environment.powerBiAnalyticsReportsName = {
            sustainability: 'ReportSection6313e08e2c700225ec0c',
            hostrevenue: 'ReportSectiond0f03865d62bc2dad499',
            chargingsessions: 'ReportSection20e37d19282bbb250b34',
        };
        environment.powerBiStationUsageName = "ReportSectionaffc5bba152083de6d26";
        environment.powerBiStationUsageReportId  ="9457fbfc-417e-477b-a598-70a4eff976f8";
        environment.powerBiStationUsageReportsName = {
            stationusage: 'ReportSectionaffc5bba152083de6d26',
        }
        break;
    case "developmentfeature3":
        environment.baseUrl = "https://apigw-feature3-qa.blinkng.com/host";
        environment.semaBaseUrl = "https://apigw-feature3-qa.blinkng.com";
        environment.keyCloakurl = "https://account-qa.blinkng.com/auth";
        environment.keyCloakClientId = "host-webapp-qa";
        environment.keyCloakRealm = "blinkcharging_feature3";
        environment.staticSiteUrl = "https://feature3-static-qa.blinkng.com";
        break;

    case "stage1uat":
        environment.baseUrl = "https://apigw-uat.blinkng.com/host";
        environment.semaBaseUrl = "https://apigw-uat.blinkng.com";
        environment.keyCloakurl = "https://account-uat.blinkng.com/auth";
        environment.keyCloakRealm = "blinkcharging";
        environment.keyCloakClientId = "host-webapp-uat";
        environment.staticSiteUrl = "https://static-uat.blinkng.com";
        environment.powerBiTenantId="46369f9c-6034-435a-9163-6c1e71b24dd6";
        environment.powerBiGroupId="555554fe-1737-466c-92b0-6749d79e39fa";
        environment.powerBiAnalyticsName  = "ReportSection9295ed54559ab933ad5d";
        environment.powerBiAnalyticsReportId ="9c25b84e-b4b7-4a5b-8c1a-f2fb8c0526b3";
        environment.powerBiAnalyticsReportsName = {
            sustainability: 'ReportSection6313e08e2c700225ec0c',
            hostrevenue: 'ReportSectiond0f03865d62bc2dad499',
            chargingsessions: 'ReportSection20e37d19282bbb250b34',
        };
        environment.powerBiStationUsageName = "ReportSectionaffc5bba152083de6d26";
        environment.powerBiStationUsageReportId  ="9457fbfc-417e-477b-a598-70a4eff976f8";
        environment.powerBiStationUsageReportsName = {
            stationusage: 'ReportSectionaffc5bba152083de6d26',
        }
        break;

    case "stage1load":
        environment.baseUrl = "https://apigw-load.blinkng.com/host";
        environment.semaBaseUrl = "https://apigw-load.blinkng.com";
        environment.keyCloakurl = "https://account-load.blinkng.com/auth";
        environment.keyCloakRealm = "blinkcharging";
        environment.keyCloakClientId = "host-webapp-load";
        environment.staticSiteUrl = "https://static-load.blinkng.com";
        break;

    case "staging":
        environment.baseUrl = "https://apigw-stage.blinkng.com/host";
        environment.semaBaseUrl = "https://apigw-stage.blinkng.com";
        environment.keyCloakurl = "https://account-stage.blinkng.com/auth";
        environment.keyCloakClientId = "host-webapp-stage";
        environment.keyCloakRealm = "blinkcharging";
        environment.staticSiteUrl = "https://blinkcdn-stage.blinkng.com";
        break;

    case "production":
        environment.baseUrl = "https://apigw.blinknetwork.com/host";
        environment.semaBaseUrl = "https://apigw.blinknetwork.com";
        environment.keyCloakurl = "https://account.blinknetwork.com/auth";
        environment.keyCloakClientId = "host-webapp-demo";
        environment.keyCloakRealm = "blinkcharging";
        environment.staticSiteUrl = "https://blinkcdn.blinknetwork.com";
        environment.powerBiTenantId="46369f9c-6034-435a-9163-6c1e71b24dd6";
        environment.powerBiGroupId="29c15c52-b748-4ebb-95cf-415eff0e98b8";
        environment.powerBiAnalyticsName  = "ReportSection9295ed54559ab933ad5d";
        environment.powerBiAnalyticsReportId ="e845e900-83fe-4c15-b114-7d7c3901b874";
        environment.powerBiAnalyticsReportsName = {
            sustainability: 'ReportSection6313e08e2c700225ec0c',
            hostrevenue: 'ReportSectiond0f03865d62bc2dad499',
            chargingsessions: 'ReportSection20e37d19282bbb250b34',
        };
        environment.powerBiStationUsageName = "ReportSectionaffc5bba152083de6d26";
        environment.powerBiStationUsageReportId  ="ca502498-9f4c-4d8a-8c48-5022e39c304a";
        environment.powerBiStationUsageReportsName = {
            stationusage: 'ReportSectionaffc5bba152083de6d26',
        }
        break;

    case "demo":
        environment.baseUrl = "https://apigw-demo.blinkng.com/host";
        environment.semaBaseUrl = "https://apigw-demo.blinkng.com";
        environment.keyCloakurl = "https://account-demo.blinkng.com/auth";
        environment.keyCloakClientId = "host-webapp-demo";
        environment.keyCloakRealm = "blinkcharging";
        environment.staticSiteUrl = "https://static-demo.blinkng.com";
        break;

    default:
}

export default environment